/// <reference path="../../types.d.ts" />
import { commonActions } from '@codametrix/ui-common';
import { connect } from 'react-redux';
import { onLoad } from '../../actions/json-view';
import { setActiveProcess } from '../../actions/json-view';
import { buildDispatchable } from '../../actions/_action-utilities';
import { JSONViewApp } from './json-view-app';
import { authenticationChannel } from '@codametrix/ui-common';
const mapStateToProps = function(state) {
    return {
        ...state.cases
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        registerActivity: ()=>{
            authenticationChannel.postMessage({
                type: commonActions.AuthenticatedWindow.ACTIVITY,
                payload: true,
                meta: {
                    suppressRedux: true
                }
            });
        },
        onLoad: (context)=>{
            runDispatchable(()=>{
                return dispatch(onLoad());
            });
        },
        setActiveProcess: (caseRun)=>{
            dispatch(setActiveProcess(caseRun));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(JSONViewApp);
